var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('div',{staticClass:"nftmax-wallet__dashboard"},[_c('BitsMonthAndSellMonthSection'),_c('currency-statcs-section'),_c('HistoryAndTopSell'),_c('ProductHistoryTable')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }